import { Selector } from '@ngxs/store';
import { InviteUsersState, InviteUsersStateModel } from './invite-users.state';

export class InviteUsersSelector {
  @Selector([InviteUsersState])
  static state(state: InviteUsersStateModel): InviteUsersStateModel {
    return state;
  }
}
